/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Top_RightInputs */



/**
* | output |
* | --- |
* | "Top Right" |
*
* @param {Input_Position_Top_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_top_right = /** @type {((inputs?: Input_Position_Top_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Top_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Haut Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вверху справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arriba a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右上角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक तरह से ऊपर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto superior direito")
	return /** @type {LocalizedString} */ ("Top Right")
});